// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1VYsR","select":"Header_select__3qjdF","clinic":"Header_clinic__J97t8"};